import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import styles from './ExpandedRoutePreview.scss'
import {Map} from 'common/Map'
import {Distance, Elevation, Grade} from 'common/units'
import {Loadable} from 'common/Loadable'
import {CoreLink} from 'common/CoreLink'
import {SHARE_DIALOG, ShareDialog} from 'common/ShareDialog'
import _ from 'lodash'
import moment from 'moment'
import {urls} from 'lib/urls'
import {CTA} from 'common/styleguide/CTA'
import {browserHistory} from 'react-router'
import {SmartExportContainer} from 'features/routes/RouteShowPage/SidePanel/SmartExport'
import {ExportDialog, EXPORT_DIALOG} from 'features/routes/RouteShowPage/dialogs/ExportDialog'
import * as routesActions from 'lib/api/routes'
// following two need to go away once we separate track data
import {deserializeRoute} from 'lib/api/records'
import {j} from 'lib/textUtils'

export class ExpandedRoutePreview extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      dialog: null,
      routeName: null,
      editing: false
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.loadableResources && !prevState.routeName) {
      this.setState({routeName: this.props.loadableResources.route.name})
    }
  }

  hideDialog = () => (
    this.setState({dialog: null})
  )

  showDialog = (dialog) => (
    this.setState({dialog: dialog})
  )

  toggleEditing = () => {
    this.setState({editing: !this.state.editing})
  }

  onRouteNameChange = (e) => {
    this.setState({routeName: e.target.value})
  }

  saveRouteName = () => {
    const {updateRoute, route, updateName} = this.props
    const {routeName} = this.state
    updateRoute(route.id, {name: routeName})
      .then(r => this.setState({editing: false}))
      .then(updateName(routeName)) // TODO remove once search is in redux
  }

  render () {
    const {dialog, routeName, editing} = this.state
    const {route, metricUnits} = this.props
    const {metrics} = route

    return (
      <div className={styles.ExpandedRoutePreview}>
        {dialog === EXPORT_DIALOG &&
        <ExportDialog onRequestClose={this.hideDialog} troute={route} objectType='route' />}
        <div className={styles.left}>
          {editing
            ? <div className={styles.editingRouteName}>
              <input value={routeName || ''} onChange={this.onRouteNameChange} className={styles.routeNameInput} />
              <span className={styles.saveButton}><CTA secondary margins={false} onClick={this.saveRouteName}>Save</CTA></span>
            </div>
            : <h3><span className={styles.routeName} onClick={this.toggleEditing}>{route.name}</span></h3>}
          <div className={styles.metrics}>
            <div className={styles.metricsSection}>
              <MetricsRow label='Created' value={moment(route.createdAt).format('MMM DD, \'YY, HH:mmA')} />
              <MetricsRow label='Starts In' value={j([route.locality, route.administrativeArea]) || '-'} />
              <MetricsRow label='Distance' M={Distance} short value={route.distance} />
              <div className={styles.metricsRow}>
                <div className={styles.metricsCol}>Elevation:</div>
                <div className={styles.metricsCol}>+<Elevation short value={route.elevationGain} />/-<Elevation short value={route.elevationLoss} /></div>
              </div>
              {metrics && metrics.grade && <MetricsRow label='Max Grade' M={Grade} short value={metrics.grade.max} />}
            </div>

            {route.description && <div className={styles.description}>{route.description}</div>}
          </div>

          <div className={styles.export}>
            <SmartExportContainer
              r={route}
              showDialog={this.showDialog}
              sendToDevice={() => browserHistory.push(`/routes/${route.id}/send_to_device`)} />
          </div>
          <div className={styles.links}>
            <div className={styles.linkWrap}>
              <CoreLink href={urls.routes.show(route.id, route.privacyCode)}>View Full Details</CoreLink>
            </div>
            <div className={styles.linkWrap}>
              <a onClick={() => this.showDialog(SHARE_DIALOG)}>Share</a>
              {dialog === SHARE_DIALOG &&
                <ShareDialog onRequestClose={this.hideDialog}
                  objectType='route'
                  objectId={route.id}
                  objectTitle={route.name}
                  privacyCode={route.privacyCode}
                  objectUrl={urls.routes.show(route.id, route.privacyCode)} />}
            </div>
          </div>
        </div>

        <div className={styles.right}>
          <Map experimental
            routes={[route]}
            metricUnits={metricUnits}
            defaultOverlay={'rwgps'}
            sampleGraph />
        </div>
      </div>
    )
  }
}

const MetricsRow = ({M, label, value, title, ...metricProps}) => {
  if (M !== undefined) {
    return (value !== null) && <div className={styles.metricsRow}>
      <div className={styles.metricsCol}>{label}:</div>
      <div className={styles.metricsCol}><span data-tip={!!title} title={title}><M value={value} {...metricProps} /></span></div>
    </div>
  } else {
    return value && <div className={styles.metricsRow}>
      <div className={styles.metricsCol}>{label}:</div>
      <div className={styles.metricsCol}><Fragment>{value}</Fragment></div>
    </div>
  }
}

const loadInitialResources = _.memoize(({troute, loadRoute}) => {
  return loadRoute(troute.id).then((r) => ({route: deserializeRoute(r.action.payload.route)}))
})

const _LoadableExpandedRoutePreview = (props) => {
  return <Loadable
    {...props}
    component={ExpandedRoutePreview}
    loadingText='Loading Route Details'
    resourceLoaded={() => loadInitialResources(props)} />
}

const mapStateToProps = (state, ownProps) => {
  return {
    route: state.routes.get(ownProps.troute.id)
  }
}

const mapDispatchToProps = {
  loadRoute: routesActions.loadRoute,
  updateRoute: routesActions.updateRoute
}

export const LoadableExpandedRoutePreview = connect(
  mapStateToProps,
  mapDispatchToProps
)(_LoadableExpandedRoutePreview)
